import {
  Box,
  alpha,
  Stack,
  lighten,
  Divider,
  styled,
  useTheme,
  IconButton,
  Tooltip
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import HeaderUserbox from './Userbox';
import Label from 'src/components/Label';
import { usePgeApi } from 'src/API/usePgeApi';
import { ApiError, ApplicationStatusInfo } from 'src/API/types/types';
import { ErrorPlaceHolder, isError } from 'src/components/PGE/ErrorPlaceHolder';
import uesApiLogic from 'src/hooks/uesApiLogic';
import DataSourceSelector from 'src/components/DataSourceSelector';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const theme = useTheme();
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);

  const { fetchApplicationStatus } = usePgeApi();

  const {
    data: services,
    error,
    refetch
  } = uesApiLogic<ApplicationStatusInfo[]>({
    apiFunction: fetchApplicationStatus
  });
  if (error)
    return (
      <ErrorPlaceHolder
        errorMessage={'Error in fetch data for Application status'}
        retryCallBack={() => {
          refetch();
        }}
      />
    );

  enum ColorMapping {
    live = 'success',
    paused = 'error',
    unknown = 'warning',
    moderate = 'info'
  }

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.2
              )}, 0px 5px 22px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}`
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        {services &&
          services?.map((service, i) => (
            <Label
              key={`app-${i}`}
              color={ColorMapping[service.status] || 'warning'}
            >
              {service.service_name}
            </Label>
          ))}
      </Stack>
      <Box display="flex" alignItems="center" gap={2}>
        <DataSourceSelector />
        <Tooltip arrow title="Toggle Menu">
          <IconButton color="primary" onClick={toggleSidebar}>
            {!sidebarToggle ? (
              <MenuTwoToneIcon fontSize="small" />
            ) : (
              <CloseTwoToneIcon fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
